module.exports = __webpack_public_path__ + "45c2ce8eca516a376cf2b446ccf6cf87.jpg";